// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1irQM","form":"styles_form__1elmB"};